import React,{createContext, useState} from "react";


interface Company {
  id: number;
  companyName: string;
  // outras propriedades...
}

interface Freight {
  id: number;
  type: string;
  deadLine: string; // ou Date, dependendo do uso
  readyToShip: string; // ou Date
  status: string;
  companyId: number;
  addressId: number;
  routeId: number | null;
  company: {
    id: number;
    companyName: string;
  };
  address: {
    id: number;
    street: string;
    number: string;
    complement: string;
    cep: number;
    neighborhood: {
      name: string;
      city: {
        name: string;
        state: {
          name: string;
          uf: string;
        };
      };
    };
  };
  route: null; // ou o tipo do objeto de rota, se houver
  load: {
    id: number;
    height: string;
    width: string;
    length: string;
    cubage: string;
    weight: string;
    detail: string;
    freightId: number;
  };
}

interface Vehicle {
  id: number;
  plate: string;
  model: string;
  year: number;
  capacity: string;
  restriction: string;
  size: string;
}
interface Router {
  id: number;
  vehicle: {
    id: number;
    plate: string;
    model: string;
    year: number;
    capacity: string;
    restriction: string;
    size: string;
  };
  url: string;
  date: string;
  status: string;
  origin: string;
  track: string;
  companyDestination?: boolean;
  freight: Freight[];
}

interface RouterContextProps {
    router: Router | null,
    setRouter: React.Dispatch<React.SetStateAction<Router|null>>
}

export const RouterContext = createContext<RouterContextProps>({
  router: {
    id: 0,
    vehicle: {
      id: 0,
      plate: '',
      model: '',
      year: 0,
      capacity: '',
      restriction: '',
      size: ''
    },
    url: '',
    date: '',
    status: '',
    origin: '',
    track: '',
    companyDestination: true,
    freight: []
  },
  setRouter: () => {}
});


export const RouterProvider: React.FC<any>= ({children})=>{
    
    const [router, setRouter] = useState<Router|null>(null);

    return(
        <RouterContext.Provider value={{router, setRouter}}>
            {children}
        </RouterContext.Provider>
    )
}